import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { VictoryStack, VictoryAxis } from 'victory-chart';
import {
  VictoryBar,
  VictoryLabel,
  VictoryChart,
  VictoryTheme,
  VictoryTooltip,
} from 'victory';
import moment from 'moment';
import {
  STYLE_AXIS_TASKS,
  STYLE_AXIS_TIME,
  STYLE_TITLE,
} from '../PPCGraph/StyleObjects';
import ColorPalette from './ColorPalette';
import RootCauseGraphLegend from './RootCauseGraphLegend';
import '../../../styles/RootCauseGraph.css';

export default class RootCauseGraph extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentProjectId: PropTypes.string.isRequired,
    data: PropTypes.object,
  };

  getTickFormat() {
    return x => moment(x).local().format('MM/DD/YYYY');
  }

  getYDomain(data) {
    return [0, data.maxTasks];
  }

  render() {
    const { data } = this.props;
    if (!data) {
      return <div />;
    }

    const tickFormat = this.getTickFormat();
    const xdomain = [data.minTick, data.maxTick];
    const ydomain = this.getYDomain(data);

    const title = 'Root Cause of Blocked Tasks';
    const graphX = 0;
    const graphY = 0;
    const graphW = 800;
    const graphH = 300;
    const viewBox = `${graphX} ${graphY} ${graphW} ${graphH}`;

    const colorScale = [];
    const categoryColors = data.categories.reduce((map, item, k) => {
        map[item] = ColorPalette[k % ColorPalette.length];
        colorScale.push(ColorPalette[k % ColorPalette.length]);
        return map;
      }, {});

    return (
      <div style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
      }}
      >
        <svg
          style={{ flex: 1 }}
          viewBox={viewBox}
        >
          <g id="rootCauseGraphContainer">
            <VictoryLabel
              x={graphW / 2 + 25}
              y={25}
              textAnchor="middle"
              verticalAnchor="start"
              lineHeight={1.2}
              style={STYLE_TITLE}
              text={title}
            />
            <g transform={'translate(0, 0)'}>
              <VictoryChart width={graphW} height={graphH} theme={VictoryTheme.material}>
                <VictoryAxis
                  domain={xdomain}
                  scale="time"
                  standalone={false}
                  offsetX={50}
                  tickValues={data.tickValues}
                  tickFormat={tickFormat}
                  style={STYLE_AXIS_TIME}
                  tickLabelComponent={<VictoryLabel textAnchor={"start"} dx={0} dy={-1} angle={20} />}
                  axisLabelComponent={<VictoryLabel dy={1} />}
                />
                <VictoryAxis
                  domain={ydomain}
                  dependentAxis
                  style={STYLE_AXIS_TASKS}
                  crossAxis
                  // tickFormat={(x) => (`$${x / 1000}k`)}
                />
                <VictoryStack
                  colorScale={colorScale.slice().reverse()}
                >
                  {data.values.slice().reverse().map((d, k) => (
                    <VictoryBar
                      labelComponent={
                        <VictoryTooltip text={x => x.label + ':' + x.tasks} />
                      }
                      key={k}
                      // categories={data.categories}
                      data={d}
                      x={'week'}
                      y={'tasks'}
                      padding={40}
                      style={{
                        data: { width: 20 },
                        parent: { border: '0px solid #ccc' },
                      }}
                    />
                  ))}
                </VictoryStack>
              </VictoryChart>
            </g>
          </g>
        </svg>
        <svg
          style={{ flex: 1 }}
          viewBox={viewBox}
        >
          <RootCauseGraphLegend categories={data.categories} categoryColors={categoryColors} />
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Project/RootCauseGraph/RootCauseGraph.js